import React from 'react';
import { Image } from '../../../Image/Image';
import { MoreInfo } from '../../MoreInfo/MoreInfo';

export const FicheMoveAtWork = (props) => {
    return (
        <div
            className={`c-fiche c-moveAtWork-full ${props.data?.hasDetail ? "u-has-detail" : ""}`}
            onClick={() => {
                if (props.data?.hasDetail && props.openPopup) {
                    props.openPopup(props.data.urlSegment);
                }
            }}
            data-aos="fade-up"
        >
            <div>
                <div className="image" title={`Meer over ${props.data.title}`}>
                    {props.data?.image?.url &&
                        <Image alt={props.data.title} src={(props.data.image.url)} />
                    }
                </div>
                <header className="c-fiche__header">
                    <h2 className="title" title={props.title}>
                        {props.data.title}
                    </h2>
                    {props.data.text}
                </header>
                <MoreInfo
                    data={props.data}
                    openPopup={props.openPopup}
                    cta={props.dictionary.howToWork} />
            </div>
        </div>
    );
}